module.exports = __webpack_public_path__ + "img/express.b7b1ffa7.png";